// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"transform-2"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 22V7H11M2 7H7M7 2L7 17H13M22 17H17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Transform2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'transform-2',
    ref,
    icon: element,
  },
));

Transform2Icon.displayName = 'Transform2Icon';

export default Transform2Icon;
